import { render, staticRenderFns } from "./registerStep1.vue?vue&type=template&id=969d1228&scoped=true&"
import script from "./registerStep1.vue?vue&type=script&lang=js&"
export * from "./registerStep1.vue?vue&type=script&lang=js&"
import style0 from "./registerStep1.vue?vue&type=style&index=0&id=969d1228&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "969d1228",
  null
  
)

export default component.exports